module.exports = __webpack_public_path__ + "static/media/Lord Milano Logo.24815ad5.svg";